import React, { useState, useEffect } from 'react';
import {
  Box, Typography, TextField, Button, Alert, Paper, CircularProgress,
} from '@mui/material';
import { useAuth } from '../AuthContext';
import AdminLayout from './AdminLayout';

function SiteSettings() {
  const { authHeaders } = useAuth();
  const [form, setForm] = useState({ featured_youtube_url: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch('/api/settings')
      .then(r => r.json())
      .then(data => setForm({ featured_youtube_url: data.featured_youtube_url || '' }))
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setSaving(true);
    setSuccess(false);
    setError('');
    const res = await fetch('/api/settings', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify(form),
    });
    setSaving(false);
    if (res.ok) {
      setSuccess(true);
    } else {
      setError('Failed to save. Try again.');
    }
  };

  return (
    <AdminLayout>
      <Box mb={4}>
        <Typography variant="h5" fontWeight={700} color="text.primary">
          Edit Home
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          Manage content shown on the public home page.
        </Typography>
      </Box>

      {loading ? (
        <CircularProgress size={28} sx={{ color: '#FFA13C' }} />
      ) : (
        <Paper
          sx={{
            backgroundColor: '#161616',
            border: '1px solid #222',
            borderRadius: 2,
            p: 3,
            maxWidth: 560,
          }}
        >
          <Typography variant="subtitle1" fontWeight={600} mb={3}>
            Featured Video
          </Typography>

          {success && <Alert severity="success" sx={{ mb: 3 }}>Saved successfully.</Alert>}
          {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit} display="flex" flexDirection="column" gap={3}>
            <TextField
              label="YouTube URL"
              value={form.featured_youtube_url}
              onChange={e => setForm(f => ({ ...f, featured_youtube_url: e.target.value }))}
              fullWidth
              size="small"
              placeholder="https://www.youtube.com/watch?v=..."
              helperText="This video appears in the 'See The Craftsmanship' section on the home page."
            />
            <Button
              type="submit"
              variant="contained"
              disabled={saving}
              sx={{
                alignSelf: 'flex-start',
                px: 4,
                py: 1.2,
                fontWeight: 600,
                backgroundColor: '#FFA13C',
                color: '#000',
                '&:hover': { backgroundColor: '#e8912e' },
              }}
            >
              {saving ? 'Saving...' : 'Save Changes'}
            </Button>
          </Box>
        </Paper>
      )}
    </AdminLayout>
  );
}

export default SiteSettings;
